import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export const CTASection = ({
  title,
  subtitle,
  primaryLabel,
  primaryTo = "/contact",
  secondaryLabel,
  secondaryTo = "/solutions",
}) => {
  const { t } = useTranslation();
  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8" data-testid="cta-section">
      <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-slate-50 p-8 sm:p-12">
        <div className="absolute inset-0 dc-soft-radial" aria-hidden />
        <div className="relative">
          <span className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-800">
            <ShieldCheck className="h-4 w-4" /> {t("ctaSection.badge")}
          </span>
          <h2 className="mt-4 max-w-3xl text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl lg:text-[44px] lg:leading-[1.08]">
            {title || t("ctaSection.title")}
          </h2>
          <p className="mt-3 max-w-2xl text-base text-slate-600 md:text-lg">{subtitle || t("ctaSection.subtitle")}</p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link to={primaryTo} data-testid="cta-primary-button">
              <Button className="h-11 rounded-lg bg-blue-600 px-5 text-white hover:bg-blue-700">
                {primaryLabel || t("cta.submit")}
                <ArrowRight className="ml-1.5 h-4 w-4" />
              </Button>
            </Link>
            <Link to={secondaryTo} data-testid="cta-secondary-button">
              <Button variant="outline" className="h-11 rounded-lg border-slate-300 bg-white px-5 text-slate-900 hover:bg-slate-50">
                {secondaryLabel || t("cta.explore")}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
